import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';
import { ConfigStateWithGridSupport } from 'widgets/store/grid/reducer';
import { OutliersColumn } from 'widgets/outliers/components/grid/columns';
import { DockingConfig } from '@instinet-analytics/semantic-ui-components';

export type OutliersPlType = 'realised' | 'unrealised' | 'total';
export type OutliersBenchmarkType = 'arrivalPrice' | 'adjustedArrivalPrice';

export const plTypeText = (p: OutliersPlType) =>
    p === 'realised' ? 'Realized' : p === 'unrealised' ? 'Unrealized' : 'Total';

export interface OutliersConfigState
    extends WidgetConfigWithHideableToolbar,
        ConfigStateWithGridSupport<OutliersColumn>,
        DockingConfig {
    plType: OutliersPlType;
    benchmarkType: OutliersBenchmarkType;
    numberOfOrders: number;
    showGrid: boolean;
    hideGridToolbar?: boolean;
    /*
     * When TRUE P&L is shown on the y-axis and performance on the x-axis
     */
    flipAxis?: boolean;
    hideTitlePanel?: boolean;
    avgPriceDecimals: number;
}

export const initialOutliersConfigState: OutliersConfigState = {
    plType: 'realised',
    benchmarkType: 'arrivalPrice',
    numberOfOrders: 5,
    hideToolbar: false,
    visibleColumns: [
        'orderID',
        'symbol',
        'side',
        'qty',
        'pnc',
        'arrivalP',
        'arrivalPAdj',
        'pnl',
        'benchmarkPerformance',
    ],
    sort: [],
    columnWidths: {},
    showGrid: true,
    hideGridToolbar: false,
    dockPosition: 'Bottom',
    dockPercentage: 30,
    avgPriceDecimals: 4,
};
